import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer"

import {baseStyles} from "../../styles"
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF"
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF"
import {PurchaseCustomerPaymentInformationPDF} from "./PurchaseCustomerPaymentInformationPDF"
import {PurchaseCustomerPriceBreakdownPDF} from "./PurchaseCustomerPriceBreakdownPDF"
import {HeaderPDF} from "../../components/HeaderPDF"
import {FooterPDF} from "../../components/FooterPDF"
import {BasePDF} from "../../BasePDF"
import {buildPdfFileName} from "../../pdfFileName"

export const PurchaseCustomerDisclosurePDF = ({companyName, customerName, customerAddress, dealState, ...props}) => (
    <BasePDF dealState={dealState} {...props}>
        <Document title={buildPdfFileName(dealState, 'Customer')}>
            <Page size="A4" style={baseStyles.page} wrap={false}>
                <View style={baseStyles.container}>
                    <HeaderPDF
                        pdfName="Customer Worksheet"
                        companyName={companyName}
                        customerName={customerName}
                        customerAddress={customerAddress}
                    />
                    <VehicleInfoPDF/>

                    <View style={baseStyles.mainGrid}>
                        <View style={[baseStyles.column, baseStyles.columnLeft]}>
                            <PurchaseCustomerPaymentInformationPDF/>
                            <FeeBreakdownPDF/>
                        </View>

                        <View style={[baseStyles.column, baseStyles.columnRight]}>
                            <PurchaseCustomerPriceBreakdownPDF/>
                        </View>
                    </View>

                    <FooterPDF showCompanyLogo/>
                </View>
            </Page>
        </Document>
    </BasePDF>
)
